import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

let originPush = VueRouter.prototype.push
let originReplace = VueRouter.prototype.replace
 
VueRouter.prototype.push = function push(location){
  return originPush.call(this,location).catch(err=>err)
}
VueRouter.prototype.replace = function push(location){
  return originReplace.call(this,location).catch(err=>err)
}

import Layout from '@/views/layout'

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   // component: () => import('../views/index/index.vue')
  // },
	{
	  path: '',
	  component: Layout,
	  redirect: 'index',
	  children: [
	    {
	      path: 'index',
	      component: (resolve) => require(['@/views/index/index'], resolve),
	      name: '首页',
	      meta: { title: '首页', keepAlive: true}
	    },
			{
			  path: '/EPD',
			  component: (resolve) => require(['@/views/EPD/index'], resolve),
			  name: 'Resource',
			  meta: { title: 'EPD', keepAlive: false}
			},
			{
			  path: '/PCR',
			  component: (resolve) => require(['@/views/PCR/index'], resolve),
			  name: 'Resource',
			  meta: { title: 'PCR', keepAlive: false}
			},
			{
			  path: '/GPI',
			  component: (resolve) => require(['@/views/GPI/index'], resolve),
			  name: 'Resource',
			  meta: { title: 'GPI', keepAlive: false}
			},
			{
			  path: '/LCA',
			  component: (resolve) => require(['@/views/LCA/index'], resolve),
			  name: 'Resource',
			  meta: { title: 'LCA'}
			},
			{
			  path: '/resource',
			  component: (resolve) => require(['@/views/resource/index'], resolve),
			  name: 'Resource',
			  meta: { title: '资源', keepAlive: false}
			},
			{
			  path: '/news',
			  component: (resolve) => require(['@/views/news/index'], resolve),
			  name: 'News',
			  meta: { title: '资讯', keepAlive: true}
			},
			{
			  path: '/service',
			  component: (resolve) => require(['@/views/service/index'], resolve),
			  name: 'Service',
			  meta: { title: '服务介绍', keepAlive: false}
			},
			{
			  path: '/connect',
			  component: (resolve) => require(['@/views/connectus/index'], resolve),
			  name: 'ConnectUs',
			  meta: { title: '联系我们', keepAlive: false}
			},
			{
			  path: '/about',
			  component: (resolve) => require(['@/views/connectus/about'], resolve),
			  name: 'About',
			  meta: { title: '关于我们', keepAlive: false}
			},
			{
			  path: '/feedback',
			  component: (resolve) => require(['@/views/connectus/feedback'], resolve),
			  name: 'Feedback',
			  meta: { title: '意见反馈', keepAlive: false}
			},
			{
			  path: '/seach',
			  component: (resolve) => require(['@/views/seach/index'], resolve),
			  name: 'Seach',
			  meta: { title: '搜索', keepAlive: false}
			},
			{
			  path: '/newsDetail',
			  component: (resolve) => require(['@/views/news/detail'], resolve),
			  name: 'NewsDetail',
			  meta: { title: '资讯详情', keepAlive: false}
			},
			{
			  path: '/notice',
			  component: (resolve) => require(['@/views/notice/index'], resolve),
			  name: 'Notice',
			  meta: { title: '公告信息', keepAlive: true}
			},
			{
			  path: '/noticeDetail',
			  component: (resolve) => require(['@/views/notice/detail'], resolve),
			  name: 'NoticeDetail',
			  meta: { title: '公告详情', keepAlive: false}
			},
			{
			  path: '/register',
			  component: (resolve) => require(['@/views/register/index'], resolve),
			  name: 'Register',
			  meta: { title: '注册', keepAlive: false}
			},
			{
			  path: '/user',
			  component: (resolve) => require(['@/views/user/index'], resolve),
			  name: 'User',
			  meta: { title: '个人中心', keepAlive: true}
			},
			{
			  path: '/portal',
			  component: (resolve) => require(['@/views/portal/portal'], resolve),
			  name: 'User',
			  meta: { title: '我的申请', keepAlive: false}
			},
			{
			  path: '/company',
			  component: (resolve) => require(['@/views/user/company'], resolve),
			  name: 'User',
			  meta: { title: '认证企业信息', keepAlive: false}
			},
			{
			  path: '/protocol',
			  component: (resolve) => require(['@/views/protocol/index'], resolve),
			  name: 'Protocol',
			  meta: { title: '协议', keepAlive: false}
			},
			{
			  path: '/apply',
			  component: (resolve) => require(['@/views/portal/apply'], resolve),
			  name: 'Apply',
			  meta: { title: '申请EPD/CFP', keepAlive: false}
			},
			{
			  path: '/applyInfo',
			  component: (resolve) => require(['@/views/portal/detail'], resolve),
			  name: 'applyInfo',
			  meta: { title: '申请详情', keepAlive: false}
			},
			{
			  path: '/taskInfo',
			  component: (resolve) => require(['@/views/portal/taskDetail'], resolve),
			  name: 'applyInfo',
			  meta: { title: '任务详情', keepAlive: false}
			},
			{
			  path: '/reportInfo',
			  component: (resolve) => require(['@/views/portal/reportDetail'], resolve),
			  name: 'applyInfo',
			  meta: { title: '报告详情', keepAlive: false}
			},
			{
			  path: '/password',
			  component: (resolve) => require(['@/views/password/index'], resolve),
			  name: 'Password',
			  meta: { title: '找回密码', keepAlive: false}
			},
	  ]
	},
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login/index.vue')
  },
	{
	  path: '/prelogin',
	  name: 'PreLogin',
	  component: () => import('../views/login/prelogin.vue')
	},
	{
	  path: '/beforeLogin',
	  name: 'BeforeLogin',
	  component: () => import('../views/login/beforeLogin.vue')
	}
]

const router = new VueRouter({
	// mode: 'history', // 去掉url中的#
	// scrollBehavior: () => ({ y: 0 }),
  routes
})

export default router
